/**
 * Family Management API Service
 * Handles all API calls for parent mode / family management
 */

import { apiService } from '@shared/services/api/ApiService';

const API_BASE = '/family';

export interface FamilyOverview {
  membershipType: string;
  membershipExpiresAt: string | null;
  childrenCount: number;
  maxMembers: number;
  children: FamilyChild[];
}

export interface FamilyChild {
  id: string;
  nickname: string;
  avatar_url: string | null;
  membershipType: string;
  lastActivityAt: string | null;
}

export interface SearchedUser {
  id: string;
  nickname: string;
  avatar_url: string | null;
  phone: string | null;
  email: string | null;
  registered_at?: string;
}

export const familyApi = {
  async getOverview(): Promise<FamilyOverview> {
    const response = await apiService.get(`${API_BASE}/overview`);
    return response.data;
  },

  async getChildren(): Promise<any[]> {
    const response = await apiService.get(`${API_BASE}/children`);
    return response.data || [];
  },

  async searchUser(query: string): Promise<SearchedUser[]> {
    const response = await apiService.post(`${API_BASE}/children/search`, { query });
    return response.data || [];
  },

  async getSuggestedUsers(): Promise<SearchedUser[]> {
    const response = await apiService.get(`${API_BASE}/children/suggested`);
    return response.data || [];
  },

  async addChild(childUserId: string): Promise<void> {
    await apiService.post(`${API_BASE}/children`, { childUserId });
  },

  async removeChild(childId: string): Promise<void> {
    await apiService.delete(`${API_BASE}/children/${childId}`);
  },
};
